"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _button = require("baseui/button");

require("./DeckSidebar.css");

var _DataInput = _interopRequireDefault(require("../DataInput"));

var _MapboxBaseLayers = _interopRequireDefault(require("../MapboxBaseLayers"));

var _utils = require("../../utils");

var _reactVis = require("react-vis");

var _Variables = _interopRequireDefault(require("../Variables"));

var _RBAlert = _interopRequireDefault(require("../RBAlert"));

var _geojsonutils = require("../../geojsonutils");

var _ColourPicker = _interopRequireDefault(require("../ColourPicker"));

var _Modal = _interopRequireDefault(require("../Modal"));

var _Table = _interopRequireDefault(require("../Table"));

var _Widgets = require("../showcases/Widgets");

var _plots = require("../showcases/plots");

var _SeriesPlot = _interopRequireDefault(require("../showcases/SeriesPlot"));

var _JSUtils = require("../../JSUtils");

var _MultiSelect = _interopRequireDefault(require("../MultiSelect"));

var _AddVIS = _interopRequireDefault(require("../AddVIS"));

var _Boxplot = _interopRequireDefault(require("../boxplot/Boxplot"));

var _LayerSettings = _interopRequireDefault(require("../settings/LayerSettings"));

var _settingsUtils = require("../settings/settingsUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var DeckSidebar = function (_React$Component) {
  _inherits(DeckSidebar, _React$Component);

  var _super = _createSuper(DeckSidebar);

  function DeckSidebar(props) {
    var _this;

    _classCallCheck(this, DeckSidebar);

    _this = _super.call(this, props);
    _this.state = {
      radius: 100,
      year: "",
      reset: false,
      multiVarSelect: {},
      barChartVariable: "road_type",
      datasetName: props.datasetName
    };
    return _this;
  }

  _createClass(DeckSidebar, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var _this$props = this.props,
          data = _this$props.data,
          alert = _this$props.alert,
          loading = _this$props.loading,
          layerStyle = _this$props.layerStyle,
          column = _this$props.column;
      var _this$state = this.state,
          reset = _this$state.reset,
          year = _this$state.year,
          barChartVariable = _this$state.barChartVariable;
      if (reset !== nextState.reset || year !== nextState.year || column !== nextProps.column || alert !== nextProps.alert || loading !== nextProps.loading || layerStyle !== nextProps.layerStyle || barChartVariable !== nextState.barChartVariable) return true;

      if (!data || data && nextProps && nextProps.data && JSON.stringify(data) === JSON.stringify(nextProps.data)) {
        return false;
      }

      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state2 = this.state,
          year = _this$state2.year,
          subsetBoundsChange = _this$state2.subsetBoundsChange,
          multiVarSelect = _this$state2.multiVarSelect,
          barChartVariable = _this$state2.barChartVariable,
          datasetName = _this$state2.datasetName;
      var _this$props2 = this.props,
          _onLayerOptionsCallback = _this$props2.onLayerOptionsCallback,
          _onSelectCallback = _this$props2.onSelectCallback,
          data = _this$props2.data,
          _colourCallback = _this$props2.colourCallback,
          unfilteredData = _this$props2.unfilteredData,
          toggleSubsetBoundsChange = _this$props2.toggleSubsetBoundsChange,
          _urlCallback = _this$props2.urlCallback,
          alert = _this$props2.alert,
          layerStyle = _this$props2.layerStyle,
          onlocationChange = _this$props2.onlocationChange,
          column = _this$props2.column,
          dark = _this$props2.dark,
          _toggleOpen = _this$props2.toggleOpen,
          toggleHexPlot = _this$props2.toggleHexPlot,
          hideChartGenerator = _this$props2.hideChartGenerator,
          hideCharts = _this$props2.hideCharts;
      var notEmpty = data && data.length > 1;
      var withRadius = !layerStyle || new RegExp("grid|sgrid|hex|scatter", "i").test(layerStyle);
      var severity_data = (0, _geojsonutils.propertyCount)(data, "accident_severity");
      var columnDomain = [];
      var columnNames = notEmpty && Object.keys(data[0].properties).filter(function (p) {
        return !(0, _JSUtils.isEmptyOrSpaces)(p);
      });
      var columnPlot = !hideCharts && notEmpty ? (0, _geojsonutils.arrayPlotProps)(data, column || barChartVariable) : [];

      var resetState = function resetState(urlOrName, button) {
        _this2.setState({
          reset: !button,
          year: "",
          multiVarSelect: {},
          barChartVariable: "road_type",
          datasetName: urlOrName || _this2.props.datasetName
        });
      };

      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
        style: _objectSpread({}, (0, _utils.theme)(dark)),
        className: "side-panel"
      }, _react["default"].createElement(_RBAlert["default"], {
        alert: alert
      }), this._headerComponent(dark, _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("h2", null, (0, _utils.getMainMessage)(data, unfilteredData)), notEmpty && _react["default"].createElement("h6", {
        className: "truncate"
      }, "dataset: ", (0, _utils.firstLastNCharacters)(datasetName, 15)))), _react["default"].createElement("div", null, _react["default"].createElement(_DataInput["default"], {
        toggleOpen: function toggleOpen() {
          return typeof _toggleOpen === 'function' && _toggleOpen();
        },
        urlCallback: function urlCallback(url, geojson, name) {
          resetState(url || name);
          typeof _urlCallback === 'function' && _urlCallback(url, geojson);
          typeof _toggleOpen === 'function' && _toggleOpen();
        }
      }), notEmpty && _react["default"].createElement(_Modal["default"], {
        toggleOpen: function toggleOpen() {
          return typeof _toggleOpen === 'function' && _toggleOpen();
        },
        component: _react["default"].createElement(_Table["default"], {
          data: data
        })
      }), this.state.reset && (!alert || !alert.content.includes("Could not reach:")) && _react["default"].createElement(_button.Button, {
        kind: _button.KIND.secondary,
        size: _button.SIZE.compact,
        onClick: function onClick() {
          resetState(undefined, true);
          typeof _urlCallback === 'function' && _urlCallback();
          typeof _this2.props.showLegend === 'function' && _this2.props.showLegend(false);
        }
      }, "Reset"), notEmpty && (0, _utils.downloadButton)(data), (0, _utils.iWithFaName)("fa fa-save", function () {
        var screenshot = _this2.props.screenshot;
        typeof screenshot === 'function' && screenshot();
      })), _react["default"].createElement("div", {
        className: "side-panel-body"
      }, _react["default"].createElement("div", {
        className: "side-panel-body-content"
      }, (0, _Widgets.yearSlider)({
        data: unfilteredData,
        year: year,
        multiVarSelect: multiVarSelect,
        onSelectCallback: _onSelectCallback,
        callback: function callback(changes) {
          return _this2.setState(changes);
        }
      }), _react["default"].createElement("br", null), severity_data && severity_data.map(function (each) {
        return (0, _utils.percentDiv)(each.x, 100 * each.y / data.length, function () {
          if (multiVarSelect && multiVarSelect['accident_severity'] && multiVarSelect['accident_severity'].has(each.x)) {
            delete multiVarSelect['accident_severity'];
          } else {
            multiVarSelect['accident_severity'] = new Set([each.x]);

            _this2.setState({
              multiVarSelect: multiVarSelect
            });
          }

          _onSelectCallback && _onSelectCallback(Object.keys(multiVarSelect).length === 0 ? {
            what: ''
          } : {
            what: 'multi',
            selected: multiVarSelect
          });
        }, dark);
      }), _react["default"].createElement("hr", {
        style: {
          clear: 'both'
        }
      }), columnDomain.length > 1 && _react["default"].createElement(_Boxplot["default"], {
        data: columnDomain
      }), _react["default"].createElement(_reactBootstrap.Tabs, {
        defaultActiveKey: "1",
        id: "main-tabs"
      }, _react["default"].createElement(_reactBootstrap.Tab, {
        eventKey: "1",
        title: _react["default"].createElement("i", {
          style: {
            fontSize: '2rem'
          },
          className: "fa fa-info"
        })
      }, !hideChartGenerator && this._panel(dark, _react["default"].createElement(_AddVIS["default"], {
        data: data,
        dark: dark,
        plotStyle: {
          width: 270,
          margin: 10
        }
      })), notEmpty && (0, _plots.plotByProperty)(data.filter(function (d) {
        return Boolean(d.properties["age_of_casualty"]);
      }), "age_of_casualty", dark, undefined, true), (0, _plots.plotByPropertyByDate)(data, "sex_of_casualty", dark), notEmpty && columnNames.length > 0 && layerStyle !== "grid" && _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("h6", null, "Column for layer:"), _react["default"].createElement(_MultiSelect["default"], {
        title: "Choose Column",
        single: true,
        value: column && {
          id: (0, _utils.humanize)(column),
          value: column
        },
        values: columnNames.map(function (e) {
          return {
            id: (0, _utils.humanize)(e),
            value: e
          };
        }),
        onSelectCallback: function onSelectCallback(selected) {
          var newBarChartVar = selected && selected[0] ? selected[0].value : barChartVariable;

          _this2.setState({
            barChartVariable: newBarChartVar
          });

          typeof _onSelectCallback === 'function' && _onSelectCallback({
            what: 'column',
            selected: newBarChartVar
          });
        }
      })), !hideCharts && _react["default"].createElement(_SeriesPlot["default"], {
        dark: dark,
        data: columnPlot.data,
        type: _reactVis.VerticalBarSeries,
        onValueClick: function onValueClick(datapoint) {
          multiVarSelect[column || barChartVariable] = new Set([datapoint.x + ""]);

          _this2.setState({
            multiVarSelect: multiVarSelect
          });

          _onSelectCallback && _onSelectCallback({
            what: 'multi',
            selected: multiVarSelect
          });
        },
        onDragSelected: function onDragSelected(datapoints) {
          multiVarSelect[column || barChartVariable] = new Set(datapoints.map(function (e) {
            return e + "";
          }));

          _this2.setState({
            multiVarSelect: multiVarSelect
          });

          _onSelectCallback && _onSelectCallback({
            what: 'multi',
            selected: multiVarSelect
          });
        },
        plotStyle: {
          marginBottom: 100
        },
        noYAxis: true
      }), !hideCharts && (0, _plots.popPyramidPlot)({
        data: data,
        dark: dark
      })), _react["default"].createElement(_reactBootstrap.Tab, {
        eventKey: "2",
        title: _react["default"].createElement("i", {
          style: {
            fontSize: '2rem'
          },
          className: "fa fa-sliders"
        })
      }, notEmpty && this._headerComponent(dark, _react["default"].createElement(_ColourPicker["default"], {
        colourCallback: function colourCallback(color) {
          return typeof _colourCallback === 'function' && _colourCallback(color);
        }
      })), notEmpty && this._panel(dark, _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("h6", null, "Deck Layer:"), _react["default"].createElement(_MultiSelect["default"], {
        title: "Choose Layer",
        single: true,
        values: _settingsUtils.LAYERS.map(function (e) {
          return {
            id: (0, _utils.humanize)(e),
            value: e
          };
        }),
        onSelectCallback: function onSelectCallback(selected) {
          if (selected && selected[0]) {
            var ls = selected[0].value;

            _this2.setState({
              layerStyle: ls
            });

            typeof _onSelectCallback === 'function' && _onSelectCallback({
              what: 'layerStyle',
              selected: ls
            });
          }
        }
      }), _react["default"].createElement(_LayerSettings["default"], {
        dark: dark,
        layerName: layerStyle,
        columnNames: columnNames,
        onLayerOptionsCallback: function onLayerOptionsCallback(layerOptions) {
          typeof _onLayerOptionsCallback === 'function' && _onLayerOptionsCallback(_objectSpread({}, layerOptions));
        }
      }))), this._headerComponent(dark, _react["default"].createElement(_react["default"].Fragment, null, "Map Styles", _react["default"].createElement("br", null), _react["default"].createElement(_MapboxBaseLayers["default"], {
        dark: dark,
        onSelectCallback: function onSelectCallback(selected) {
          return _onSelectCallback && _onSelectCallback({
            selected: selected,
            what: 'mapstyle'
          });
        }
      }))), notEmpty && withRadius && _react["default"].createElement(_reactBootstrap.Checkbox, {
        onChange: function onChange() {
          return toggleHexPlot && toggleHexPlot();
        }
      }, "Hex Plot"), notEmpty && _react["default"].createElement(_reactBootstrap.Checkbox, {
        onChange: function onChange() {
          _this2.setState({
            subsetBoundsChange: !subsetBoundsChange
          });

          if (toggleSubsetBoundsChange && typeof toggleSubsetBoundsChange === 'function') {
            toggleSubsetBoundsChange(!subsetBoundsChange);
          }
        }
      }, "Subset by map boundary")), unfilteredData && unfilteredData.length > 0 && _react["default"].createElement(_reactBootstrap.Tab, {
        eventKey: "3",
        title: _react["default"].createElement("i", {
          style: {
            fontSize: '2rem'
          },
          className: "fa fa-filter"
        }, multiVarSelect && Object.keys(multiVarSelect).length ? Object.keys(multiVarSelect).length : "")
      }, this._headerComponent(dark, _react["default"].createElement(_Variables["default"], {
        dark: dark,
        multiVarSelect: multiVarSelect,
        onSelectCallback: function onSelectCallback(mvs) {
          typeof _onSelectCallback === 'function' && _onSelectCallback(Object.keys(mvs).length === 0 ? {
            what: ''
          } : {
            what: 'multi',
            selected: mvs
          });

          _this2.setState({
            multiVarSelect: mvs
          });
        },
        unfilteredData: unfilteredData
      }))))), this.props.leftSidebarContent, _react["default"].createElement("div", {
        className: "space"
      }), notEmpty && this._headerComponent(dark, "Vis: " + (layerStyle || "None")), _react["default"].createElement("form", {
        className: "search-form",
        onSubmit: function onSubmit(e) {
          e.preventDefault();
          (0, _utils.searchNominatom)(_this2.state.search, function (json) {
            var bbox = json && json.length > 0 && json[0].boundingbox;
            bbox = bbox && bbox.map(function (num) {
              return +num;
            });
            typeof onlocationChange === 'function' && bbox && onlocationChange({
              bbox: bbox,
              lon: +json[0].lon,
              lat: +json[0].lat
            });
          });
        }
      }, _react["default"].createElement(_reactBootstrap.FormGroup, null, _react["default"].createElement(_reactBootstrap.InputGroup, null, _react["default"].createElement(_reactBootstrap.FormControl, {
        style: {
          background: dark ? '#242730' : 'white',
          color: dark ? 'white' : 'black'
        },
        onChange: function onChange(e) {
          return _this2.setState({
            search: e.target.value
          });
        },
        placeholder: "fly to...",
        type: "text"
      }), _react["default"].createElement(_reactBootstrap.InputGroup.Addon, {
        style: {
          background: dark ? '#242730' : 'white',
          color: dark ? 'white' : 'black'
        }
      }, _react["default"].createElement(_reactBootstrap.Glyphicon, {
        glyph: "search"
      }))))))));
    }
  }, {
    key: "_headerComponent",
    value: function _headerComponent(dark, content) {
      return _react["default"].createElement("div", {
        style: {
          marginTop: 2,
          background: dark ? '#29323C' : '#eee'
        },
        className: "side-pane-header"
      }, content);
    }
  }, {
    key: "_panel",
    value: function _panel(dark, content) {
      return _react["default"].createElement("div", {
        style: {
          borderColor: dark ? '#29323C' : '#eee'
        },
        className: "side-panel-group"
      }, content);
    }
  }]);

  return DeckSidebar;
}(_react["default"].Component);

exports["default"] = DeckSidebar;